"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.04883,10.7334v-2.91016c0-.41406-.33594-.75-.75-.75s-.75,.33594-.75,.75v3.2207c0,.19922,.0791,.38965,.21973,.53027l1.61035,1.60938c.14648,.14648,.33887,.21973,.53027,.21973,.19238,0,.38379-.07324,.53027-.21973,.29297-.29297,.29297-.76758,0-1.06055l-1.39062-1.38965Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.34644,9.6543c-.64966-3.302-3.55884-5.80176-7.04761-5.80176-3.96582,0-7.19141,3.22559-7.19141,7.19141,0,3.96484,3.22559,7.19043,7.19141,7.19043,1.72021,0,3.2981-.61133,4.53662-1.62305,.71606,1.42114,1.54321,2.76416,1.80811,3.18555,.13672,.21777,.37695,.35059,.63477,.35059s.49805-.13281,.63477-.35059c.49805-.79102,2.97949-4.82422,2.97949-6.53613,0-1.96875-1.58521-3.56909-3.54614-3.60645Zm-7.04761,7.08008c-3.13867,0-5.69141-2.55273-5.69141-5.69043,0-3.13867,2.55273-5.69141,5.69141-5.69141,2.75806,0,5.03735,1.98096,5.55396,4.59033-1.28491,.55444-2.18774,1.83203-2.18774,3.31787,0,.49316,.20947,1.18115,.5144,1.92651-1.01733,.95483-2.37842,1.54712-3.88062,1.54712Zm6.97949,1.21387c-1.02246-1.75195-2.11328-3.91113-2.11328-4.6875,0-1.16504,.94824-2.11328,2.11328-2.11328,1.16602,0,2.11426,.94824,2.11426,2.11328,0,.77539-1.0918,2.93555-2.11426,4.6875Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.27856,12.39746c-.47705,0-.86377,.38672-.86377,.86353,0,.47705,.38672,.86353,.86377,.86353,.47681,0,.86353-.38647,.86353-.86353,0-.47681-.38672-.86353-.86353-.86353Z"
  }));
};

exports["default"] = _default;